import React from 'react';

import { usePortalDomain } from '@portals/framework';

import BrowserMock from '../../../components/OnboardingWizard/BrowserMock';
import { StoreBrowserMock } from '../../../components/OnboardingWizard/StoreBrowserMock';
import { useBrandingContext } from '../branding.context';

export function StorePreview() {
  const portalDomain = usePortalDomain();
  const { portalConfig } = useBrandingContext();

  return (
    <div className="browser-mock-wrapper">
      <BrowserMock portalConfig={portalConfig} domain={portalDomain}>
        <StoreBrowserMock />
      </BrowserMock>
    </div>
  );
}
